import React, { useEffect } from 'react';
import { useAuth } from '../components/context/AuthContext';
import { Page } from '../types';
import LoadingSpinner from '../components/LoadingSpinner';
import PageWrapper from '../components/PageWrapper';

interface LoginPageProps {
    navigateTo: (page: Page) => void;
    initialPrompt: string | null;
    showNotification: (message: string, type: 'success' | 'error' | 'info') => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ navigateTo, initialPrompt }) => {
    const { login, isAuthenticated, isLoading } = useAuth();

    useEffect(() => {
        if (isAuthenticated) {
            if (initialPrompt) {
                navigateTo('workspace');
            } else {
                navigateTo('dashboard');
            }
        }
    }, [isAuthenticated, navigateTo, initialPrompt]);

    // Show a spinner while Auth0 is initializing or redirecting
    if (isLoading) {
        return <div className="pt-20 flex-grow flex items-center justify-center"><LoadingSpinner /></div>;
    }

    return (
        <PageWrapper>
            <div className="py-20 sm:py-32 flex-grow flex items-center justify-center">
                <div className="bg-[var(--panel-bg)] backdrop-blur-sm border border-[var(--border-color)] rounded-2xl p-8 md:p-12 w-full max-w-md text-center">
                    <h1 className="text-3xl font-extrabold text-[var(--text-primary)]">
                        Welcome Back
                    </h1>
                    <p className="mt-2 text-[var(--text-secondary)] mb-8">
                        Log in or create an account to continue.
                    </p>
                    <button 
                        onClick={() => login()} 
                        className="w-full px-8 py-3 text-base font-semibold text-white bg-gradient-to-r from-[var(--gradient-from)] to-[var(--gradient-to)] rounded-md hover:opacity-90 transition-opacity"
                    >
                        Continue
                    </button>
                </div>
            </div>
        </PageWrapper>
    );
};

export default LoginPage;